<template>
  <div class="mt-5">
    <div v-for="n in pageSize" class="card section-blog__card--page-blog skeleton-block mt-3">
      <div class="card-img-top section-blog__card-img section-blog__card-img--size-big skeleton-block"> </div>
      <div class="card-body section-blog__card-body bg-white w-100 px-4">
        <h4 class="section-blog__title skeleton-txt my-3"><div class="skeleton-txt skeleton-txt--50"></div></h4>
        <div class="skeleton-txt skeleton-txt--100 mb-1"></div>
        <div class="skeleton-txt skeleton-txt--100 mb-1"></div>
        <div class="skeleton-txt skeleton-txt--100 mb-1"></div>
        <div class="skeleton-txt skeleton-txt--100 mb-1"></div>
        <div class="d-flex justify-content-end">
            <div class="skeleton-txt skeleton-txt--25 mt-3">
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    pageSize: Number,
  }
}
</script>

<style></style>